// Copyright (c) 2016 Deere & Company

import actions from '../../actions-list';
import {getDefaultState} from '../state/dealer-recommendation-list';

const checkboxDealerRecommendations = (state, action) => {

    /* eslint-enable array-callback-return, consistent-return */

    let updateState;
    const idx = state.indexOf(action.dealerRecommendation.id);

    if (idx >= 0) {

        state.splice(idx, 1);
        updateState = [...state];

    } else {

        updateState = [...state, action.dealerRecommendation.id];

    }
    return updateState;

};

const updateAllDealerRecommendations = (state, action) =>
    state.length ?
        [] :
        action.dealerRecommendation;
const resetSelectedDealerRecommendations = () => [];

export default (state = getDefaultState().elements, action) => {

    const actionTypes = {
        [actions.UPDATE_SELECTED_DEALER_RECOMMENDATIONS]: checkboxDealerRecommendations,
        [actions.UPDATE_SELECTED_ALL_DEALER_RECOMMENDATIONS]: updateAllDealerRecommendations,
        [actions.RESET_SELECTED_DEALER_RECOMMENDATIONS]: resetSelectedDealerRecommendations
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/product/dealer-recommendations/reducers/checkbox-dealer-recommendation.js